type SegmentedTabsOption<T extends string> = { value: T; label: string };

type SegmentedTabsProps<T extends string> = {
    options: SegmentedTabsOption<T>[];
    value: T;
    onChange: (value: T) => void;
};

export default function SegmentedTabs<T extends string>({ options, value, onChange }: SegmentedTabsProps<T>) {
    return (
        <div className="inline-flex rounded-full overflow-hidden">
            {options.map((opt) => (
                <button
                    key={opt.value}
                    onClick={() => onChange(opt.value)}
                    className={`px-4 py-2 text-base whitespace-nowrap cursor-pointer transition-colors ${
                        value === opt.value ? "text-white" : "bg-gray-200 hover:bg-gray-300 text-gray-700"
                    }`}
                    style={value === opt.value ? { backgroundColor: "dodgerblue" } : {}}
                >
                    {opt.label}
                </button>
            ))}
        </div>
    );
}
